import { useNavigate } from 'react-router-dom';
import { BookingConfirmation } from '@fittrack/ui';
import type { BookingResponse } from '@fittrack/services';
import type { EnrollmentReserveResponse } from '@fittrack/ui';
import '../pages/EnrollPage.css';

export default function EnrollConfirmationPage() {
  const navigate = useNavigate();
  const stored = sessionStorage.getItem('pwaEnrollmentConfirmation');

  if (!stored) {
    navigate('/enroll', { replace: true });
    return null;
  }

  const enrollmentResponse: EnrollmentReserveResponse = JSON.parse(stored);

  const bookingResponse: BookingResponse = {
    success: enrollmentResponse.success,
    message: enrollmentResponse.message,
    attendeeId: enrollmentResponse.personId ? Number(enrollmentResponse.personId) : undefined,
    confirmation: enrollmentResponse.confirmation
      ? {
          personName: enrollmentResponse.confirmation.personName,
          photoUrl: enrollmentResponse.confirmation.photoUrl,
          qrCodeUrl: enrollmentResponse.confirmation.qrCodeUrl,
          siteName: enrollmentResponse.confirmation.siteName,
          siteAddress1: enrollmentResponse.confirmation.siteAddress1,
          siteAddress2: enrollmentResponse.confirmation.siteAddress2,
        }
      : undefined,
  };

  return (
    <BookingConfirmation
      bookingResponse={bookingResponse}
      onClose={() => {
        sessionStorage.removeItem('pwaEnrollmentConfirmation');
        navigate('/enroll', { replace: true });
      }}
    />
  );
}
